import {
  applyPolyfills,
  defineCustomElements,
} from '@renfe/ui-kit/dist/loader';
import { ConnectedRouter } from 'connected-react-router';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import 'scss/styles.scss';
import { history, persistor, store } from 'store/configureStore';
import App from './App';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

applyPolyfills().then(() => {
  defineCustomElements(window);
});
